import Hero from './Hero'
import MovieTrailer from './MovieTrailer'
import { useParams } from 'react-router-dom'
import { useState, useEffect } from 'react'

const MovieView = () => {
	//this gets the parameter out of the URL to be used to get the rest of the data on this page
	const { id } = useParams()
	const [movieDetails, setMovieDetails] = useState({})
	const [isLoading, setIsLoading] = useState(true)
	const [movieVideos, setMovieVideos] = useState([])

	//this is watching the id and anytime the id changes in the URL it's going to make an api request and populate the MovieView page with the data.
	useEffect(() => {
		fetch(
			`https://api.themoviedb.org/3/movie/${id}?api_key=23f28c668f59a7895010a1481a3df51d&append_to_response=videos&language=en-US`
		)
			.then((response) => response.json())
			.then((data) => {
				setMovieDetails(data)
				//to get the array of videos
				setMovieVideos(data.videos.results)
				// imdb id - https://www.imdb.com/title/tt7319486/  id is at the end
				console.log(data)
				setIsLoading(false)
			})
	}, [id])

	//show the page is loading
	function renderMovieDetails() {
		if (isLoading) {
			return <Hero text="Loading..." />
		}
		if (movieDetails) {
			//Deal with a possible missing image
			//if conditional that changes the posterpath
			// const posterPath = `https://image.tmdb.org/t/p/original/${movieDetails.poster_path}`
			// const backdropUrl = `https://image.tmdb.org/t/p/original/${movieDetails.backdrop_path}`
			return (
				// if  no data comes back for a title then show no information availiable for this movie
				<>
					<Hero
						text={movieDetails.original_title}
						// backdrop={backdropUrl}
						className="w-100"
					/>
					<div></div>
					<div className="movieContainer container my-5 mt-5">
						<div className="row mt-5 d-flex">
							{/* <div className='col-md-3'>
								<img
									src={posterPath}
									alt='...'
									className='img-fluid shadow rounded'
								/>
							</div> */}
							<div className="col trailer-column d-flex flex-column align-items-center">
								<div className="container-1 d-flex flex-column align-items-center">
									<MovieTrailer videos={movieVideos} />
								</div>
								<div className="container mx-auto">
									<p className="lead mt-5 ">{movieDetails.overview}</p>
									<p className="lead mt-2">Tagline: "{movieDetails.tagline}"</p>
									<p className="lead mt-2">{movieDetails.runtime} min</p>
									<a
										className="lead"
										target="_blank"
										href={`https://www.imdb.com/title/${movieDetails.imdb_id}/`}
									>
										IMDB Page
									</a>
								</div>
							</div>
						</div>
					</div>
				</>
			)
		}

		// else block
	}

	return renderMovieDetails()
}

export default MovieView
